<template>
  <main>
    <div class="site-content" id="site-content">
      <div class="timetable-container">
        <div class="monthPlanning">
          <transition :name="transition" mode="out-in">
            <div class="monthName" v-bind:key="monday.getMonth().toString()">
              <transition name="fade">
                <i class="material-icons" :data-week="getWeekNumber(monday)"
                  >calendar_today</i
                >
              </transition>
              <strong>{{ textDate(monday)[2].toUpperCase() }}</strong>
              {{ textDate(monday)[3] }}
            </div>
          </transition>
          <div class="controls">
            <button @click="updatePlanning(-7)">&lt;</button>
            <span>/</span>
            <button @click="updatePlanning(7)">&gt;</button>
          </div>
        </div>
        <div class="containerPlanning">
          <div class="hour">
            <p>08:00</p>
            <p>09:00</p>
            <p>10:00</p>
            <p>11:00</p>
            <p>12:00</p>
            <p>13:00</p>
            <p>14:00</p>
            <p>15:00</p>
            <p>16:00</p>
            <p>17:00</p>
            <p>18:00</p>
          </div>
          <transition :name="transition" mode="out-in">
            <div
              v-if="planning != null"
              class="plateau"
              v-bind:key="today.toString()"
            >
              <div
                v-for="day in Object.keys(planning)"
                v-bind:key="day + 'd'"
                class="case"
              >
                <span v-html="textDate(day).slice(0, 2).join(' ')"></span>
              </div>
              <div
                v-for="day in Object.keys(planning)"
                v-bind:key="day"
                class="case"
              >
                <hr v-for="i in generateRange(0, 10, 1)" v-bind:key="i" />
                <div
                  v-for="cours in filterByGroup(planning[day])"
                  v-bind:key="cours.uid + cours.start"
                  class="cours hoverable"
                  :style="{
                    height:
                      parseInt(cours.end.split(':')[0]) * 60 +
                      parseInt(cours.end.split(':')[1]) -
                      (parseInt(cours.start.split(':')[0]) * 60 +
                        parseInt(cours.start.split(':')[1])) -
                      2 +
                      'px',
                    top:
                      parseInt(cours.start.split(':')[0]) * 60 +
                      parseInt(cours.start.split(':')[1]) -
                      479 +
                      'px',
                    backgroundColor: moduleColor(cours.module),
                  }"
                >
                  <div class="module">{{ cours.module }}</div>
                  <div
                    v-if="cours.subtitle"
                    class="subtitle"
                    v-html="createTextLinks(cours.subtitle)"
                  ></div>
                  <div class="prof" v-if="cours.teachers != undefined">
                    <i class="material-icons-outlined">emoji_people</i>
                    {{ cours.teachers.join(", ") }}
                  </div>
                  <div class="courseType">
                    <span v-if="cours['type']" class="timer">
                      <!--<i class="material-icons-outlined">alarm</i>-->
                      {{ cours["type"] ? cours["type"].split("_")[0] : "" }}
                    </span>
                  </div>
                  <div
                    class="after"
                    :style="{
                      backgroundImage:
                        'url(\'/img/modules/' +
                        moduleIcon(cours.module) +
                        '.svg\')',
                    }"
                  ></div>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="site-cache" id="site-cache"></div>
  </main>
</template>

<style>
.monthName {
  display: inline-block;
}

.cours .subtitle a {
  color: white;
  text-decoration: none;
  border-bottom: 1px dotted white;
}

.cours.hoverable:hover {
  z-index: 4;
}
</style>

<style scoped>
.courseType .timer {
  background-color: rgba(22, 22, 22, 0.164);
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
}

.monthPlanning {
  margin: 20px 25px 0 80px;
  font-size: 46px;
}

.monthPlanning strong {
  font-weight: 600;
}

.monthPlanning i {
  margin-right: 0.3em;
  font-size: 46px;
  vertical-align: -10%;
}

.monthPlanning i::before {
  content: attr(data-week);
  font-family: "Lato";
  position: absolute;
  font-size: 0.5em;
  width: 2em;
  height: 2em;
  text-align: center;
  line-height: 2.4em;
}

.containerPlanning {
  overflow: hidden;
  display: flex;
  padding: 10px 20px;
}

.hour {
  margin: 30px 20px 0px 0px;
}

.hour p:first-child {
  margin-top: 0px;
}

.hour p:nth-child(n + 2) {
  margin-top: 37px;
}

.plateau {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: 30px 1fr;
  box-sizing: border-box;
  gap: 10px;
  width: 100%;
  overflow: auto;
  background-color: rgb(244 244 244);
}
.case {
  position: relative;
  min-width: 160px;
}

.case hr {
  border: none;
  border-top: 1px dashed #ccc;
}

.case hr:nth-child(n + 2) {
  margin-top: 59px;
}

.case hr:first-child {
  margin-top: 0;
}

.case:nth-child(-n + 6) {
  text-align: center;
  justify-content: center;
  align-items: center;
  line-height: 30px;
  background-color: #afdab9;
  color: white;
}

.case:nth-child(n + 7) {
  background-color: #eeeeee;
}

.case:nth-child(n + 7)::before {
  display: block;
  text-align: left;
  margin-left: 10px;
  height: 20px;
  font-weight: bold;
}

.cours {
  position: absolute;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 0px 5px 0px 5px;
  width: 100%;
  border-radius: 8px;
  font-size: 12px;
  color: white;
  background-color: #888;
}

.cours .after {
  content: "";
  opacity: 0.1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  position: absolute;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 90% 90%;
  pointer-events: none;
  /*z-index: -1;*/
}

.module {
  font-weight: bold;
}

.prof {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  color: white;
  /*white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  align-self: flex-start;*/
}

.prof i {
  font-size: 14px;
  margin-right: 3px;
}

@media screen and (max-width: 680px) {
  .monthPlanning {
    margin: 20px 25px 0 25px;
    text-align: center;
    font-size: 8vw;
  }

  .monthPlanning i {
    font-size: 8vw;
  }
}
</style>

<script>
import M from "materialize-css";
import { mapState } from "vuex";
import * as firebase from "firebase/app";
import "firebase/database";
const rtdb = firebase.database();

export default {
  data() {
    return {
      today: new Date(),
      monday: new Date(),
      saturday: new Date(),
      dateText: null,
      month: null,
      transition: "fade",
      planning: null,
      lastUpdate: null,
      presence: "",
      presenceWeeksHoliday: [44, 52, 53, 7, 16],
      presenceWeeksPrime: [37, 39, 41, 43, 46, 48, 50, 1, 3],
      presenceWeeksSeconde: [38, 40, 42, 45, 47, 49, 51, 2],
    };
  },
  methods: {
    generateRange(min, max, step) {
      let arr = [];
      for (let i = min; i <= max; i += step) {
        arr.push(i);
      }
      return arr;
    },
    textDate(inputFormat) {
      var jours = ["DIM", "LUN", "MAR", "MER", "JEU", "VEN", "SAM"];
      var mois = [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Août",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ];
      var d = new Date(inputFormat);
      return [
        jours[d.getDay()],
        d.getDate() == 1 ? d.getDate() + "<sup>er</sup>" : d.getDate(),
        mois[d.getMonth()],
        this.pad(d.getFullYear()),
      ];
    },
    pad(s) {
      return s < 10 ? "0" + s : s;
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = "" + d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    sort_by_key(array, key) {
      if (array == null) return [];

      return array
        .sort(function (a, b) {
          var x = a[key];
          var y = b[key];
          return x < y ? -1 : x > y ? 1 : 0;
        })
        .filter(
          (e) => !e["options"] || (this.userProfile.options !== undefined && this.userProfile["options"].filter(function(o) { return e.options.indexOf(o) !== -1; }).length > 0)
        );
    },
    filterByGroup(e) {
      return e.filter(
        (e) => !e["options"] || (this.userProfile.options !== undefined && this.userProfile["options"].filter(function(o) { return e.options.indexOf(o) !== -1; }).length > 0)
      )},
    pSBC(p, c0, c1, l) {
      let r,
        g,
        b,
        P,
        f,
        t,
        h,
        i = parseInt,
        m = Math.round,
        a = typeof c1 == "string";
      if (
        typeof p != "number" ||
        p < -1 ||
        p > 1 ||
        typeof c0 != "string" ||
        (c0[0] != "r" && c0[0] != "#") ||
        (c1 && !a)
      )
        return null;
      if (!this.pSBCr)
        this.pSBCr = (d) => {
          let n = d.length,
            x = {};
          if (n > 9) {
            ([r, g, b, a] = d = d.split(",")), (n = d.length);
            if (n < 3 || n > 4) return null;
            (x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))),
              (x.g = i(g)),
              (x.b = i(b)),
              (x.a = a ? parseFloat(a) : -1);
          } else {
            if (n == 8 || n == 6 || n < 4) return null;
            if (n < 6)
              d =
                "#" +
                d[1] +
                d[1] +
                d[2] +
                d[2] +
                d[3] +
                d[3] +
                (n > 4 ? d[4] + d[4] : "");
            d = i(d.slice(1), 16);
            if (n == 9 || n == 5)
              (x.r = (d >> 24) & 255),
                (x.g = (d >> 16) & 255),
                (x.b = (d >> 8) & 255),
                (x.a = m((d & 255) / 0.255) / 1000);
            else
              (x.r = d >> 16),
                (x.g = (d >> 8) & 255),
                (x.b = d & 255),
                (x.a = -1);
          }
          return x;
        };
    },
    /*updatePlanning(step) {
      this.transition = step < 0 ? "previous" : step > 0 ? "next" : "fade";
      this.date.setDate(this.date.getDate() + step);

      if (this.date.getDay() == 0) {
        this.date.setDate(this.date.getDate() + step);
      }

      if (this.date.toJSON() <= new Date("2020-09-06").toJSON()) {
        this.date = new Date("2020-09-07");
        //M.toast({ html: "Impossible de reculer plus !" });
      } else if (this.date.toJSON() >= new Date("2021-07-01").toJSON()) {
        this.date = new Date("2021-06-30");
        //M.toast({ html: "Impossible d'avancer plus !" });
      }

      var events = [];

      var semester = 1;

      var groupRef = rtdb.ref(
        "planning/" +
          this.userProfile["group" + semester] +
          (this.userProfile["subgroup" + semester] == "prime" ? "'" : "''") +
          "/" +
          this.formatDate(this.date)
      );
      var self = this;
      groupRef.on("value", function(snapshot) {
        events.push.apply(events, snapshot.val());
        self.planning = self.sort_by_key(events, "start");
        self.dateText = self
          .textDate(self.date)
          .slice(0, 2)
          .join(" ");
        self.month = self.textDate(self.date)[2];
        self.presence =
          (self.presenceWeeksPrime.includes(self.getWeekNumber(self.date)) &&
            self.userProfile.subgroup1 == "prime") ||
          (self.presenceWeeksSeconde.includes(self.getWeekNumber(self.date)) &&
            self.userProfile.subgroup1 == "seconde")
            ? "business"
            : self.presenceWeeksHoliday.includes(self.getWeekNumber(self.date))
            ? "beach_access"
            : "home";
      });
    },*/
    updatePlanning(step) {
      this.transition = step < 0 ? "previous" : step > 0 ? "next" : "fade";
      this.today.setDate(this.today.getDate() + step);

      this.monday = new Date(
        this.today.setDate(this.today.getDate() - this.today.getDay() + 1)
      );
      this.saturday = new Date(
        this.today.setDate(this.today.getDate() - this.today.getDay() + 6)
      );

      if (this.saturday.toJSON() < new Date("2020-09-06").toJSON()) {
        this.today.setDate(this.today.getDate() - step);

        this.monday = new Date(
          this.today.setDate(this.today.getDate() - this.today.getDay() + 1)
        );
        this.saturday = new Date(
          this.today.setDate(this.today.getDate() - this.today.getDay() + 6)
        );
        M.toast({ html: "Impossible de reculer plus !" });
      } else if (this.today.toJSON() > new Date("2021-07-01").toJSON()) {
        this.today.setDate(this.today.getDate() - step);

        this.monday = new Date(
          this.today.setDate(this.today.getDate() - this.today.getDay() + 1)
        );
        this.saturday = new Date(
          this.today.setDate(this.today.getDate() - this.today.getDay() + 6)
        );
        M.toast({ html: "Impossible d'avancer plus !" });
      }

      var path =
        "planning/" +
        this.userProfile["group1"] +
        (this.userProfile["subgroup1"] != ""
          ? "-" + this.userProfile["subgroup1"]
          : "");
      if (this.today.toJSON() > new Date("2021-01-24").toJSON())
        path =
          "planning/" +
          this.userProfile["group2"] +
          (this.userProfile["subgroup2"] != ""
            ? "-" + this.userProfile["subgroup2"]
            : "");
      // régler l'erreur à la deconnexion

      var planningRef = rtdb
        .ref(path)
        .orderByKey()
        .startAt(this.formatDate(this.monday))
        .endAt(this.formatDate(this.saturday));
      var self = this;
      planningRef.on("value", function (snapshot) {
        self.planning = {};
        for (
          var d = new Date(self.monday);
          d <= self.saturday;
          d.setDate(d.getDate() + 1)
        ) {
          self.planning[self.formatDate(d)] = [];
        }
        var data = snapshot.val();
        for (var day in data) {
          self.planning[day] = data[day];
        }
      });
    },
    getWeekNumber(dt) {
      var tdt = new Date(dt.valueOf());
      var dayn = (dt.getDay() + 6) % 7;
      tdt.setDate(tdt.getDate() - dayn + 3);
      var firstThursday = tdt.valueOf();
      tdt.setMonth(0, 1);
      if (tdt.getDay() !== 4) {
        tdt.setMonth(0, 1 + ((4 - tdt.getDay() + 7) % 7));
      }
      return 1 + Math.ceil((firstThursday - tdt) / 604800000);
    },
    createTextLinks(text) {
      return (text || "").replace(
        /([^\S]|^)(((https?:\/\/)|(www\.))(\S+))/gi,
        function (match, space, url) {
          var hyperlink = url;
          if (!hyperlink.match("^https?://")) {
            hyperlink = "http://" + hyperlink;
          }
          return (
            space + '<a href="' + hyperlink + '" target="_blank">(Lien)</a>'
          );
        }
      );
    },
    initialize() {
      this.updatePlanning(0);
    },
    moduleColor(moduleName) {
      if (Object.keys(this.modulesByAlias).includes(moduleName)) {
        return this.modules[this.modulesByAlias[moduleName]].color;
      } else {
        return "#7f8c8d";
      }
    },
    moduleIcon(moduleName) {
      if (Object.keys(this.modulesByAlias).includes(moduleName)) {
        return this.modules[this.modulesByAlias[moduleName]].icon;
      } else {
        return "default";
      }
    },
  },
  computed: {
    ...mapState(["userProfile", "modules", "modulesByAlias"]),
  },
  watch: {
    userProfile() {
      if (this.modules != undefined) this.initialize();
    },
    modules() {
      if (this.userProfile != undefined) this.initialize();
    },
  },
  mounted() {
    if (this.userProfile != undefined && this.modules != undefined)
      this.initialize();
  },
};
</script>